<template>
  <v-card class="text-center" outlined tile>
    m<sup>2</sup> x
    <Paquete class="ml-1 mr-1" />
  </v-card>
</template>

<script>
import { Paquete } from '../Icons';

export default {
    components: { Paquete }
}
</script>

<style>

</style>